import { useState, useEffect } from "react";

// ApiState is a hook that manages the state of an API call
// it will load the data on init if loadOnInit is true
export default function ApiState({
    apiCall,
    loadOnInit = false,
    additionalParams = {}
}) {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [isReady, setIsReady] = useState(false);

    useEffect(() => {
        if (loadOnInit) {
            loadData();
        }
    });

    const loadData = async () => {
        if (loading) {
            return;
        }
        setLoading(true);
        try {
            const response = await apiCall(additionalParams);
            setData(response);
        } catch (error) {
            setError(error);
        }
        setIsReady(true);
        setLoading(false);
    };

    return { data, loading, error, isReady, loadData };
}